import { Variables } from "./Variables";
import triggerIcon from "../../../../new-images/profile/trigger-icon.svg";
import triggerIconSuccess from "../../../../new-images/profile/trigger-icon-success.svg";
import successImg from "../../../../new-images/profile/success.svg";

export const useEmailReconfirmationVariables = (email) => {

  return new Variables(
    {
      title: `Нам важно оставаться на связи.
      Вы получаете от нас рассылки на этот`,
      bold: " email?",
      img: triggerIcon,
      prompt:
        "Вы подтвердили свой email более года назад. Если этот email больше не актуален, то укажите, пожалуйста, новый.",
      centralText: email,
      button: "Нет",
      confirmBtn: "Да",
    },
    {
      title: "Подтверждение email",
      img: triggerIconSuccess,
      centralText: email,
      message: "Email подтвержден",
      succesImg: successImg,
    }
  )
};
